var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RuleConditionList',{attrs:{"value":_vm.value,"conditionDefinitions":_vm.conditionDefinitions,"users":_vm.users,"groups":_vm.groups,"categories":_vm.categories,"tags":_vm.tags,"templates":_vm.templates,"checklists":_vm.checklists,"depth":0},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }